define('services/nutrition/nutrients',[
    'underscore', 'backbone', 'moment', 'utils',
    // services
    'services/api',
    'src/service',
    // models & collections
    'collections/calendar/nutrition/nutrients',
    // 'models/calendar/nutrition/nutrient'
], function(
    _, Backbone, moment, U,
    // services
    API,
    Service,
    // models & collections
    CNutrients
) {

    //////////////////////////////
    // Private static variables //
    //////////////////////////////
    var AllNutrient = Backbone.Model.extend({
        urlRoot: API.url("nutrition/nutrients"),
        defaults: {
            macronutrients: null,
            micronutrients: null
        },
        parse: function(response) {
            if (_.has(response, 'macronutrients')) {
                _.each(response.macronutrients, function(nutrient) {
                    nutrient.macro = true;
                });
            }
            return response;
        },
    });

    /**
     * [NutrientService description]
     * @type {[type]}
     */
    var NutrientService = Service.extend({

        weight: {
            carbohydrate: 4,
            fat: 9,
            protein: 4,
            alcohol: 7
        },

        initialize: function(options) {
            this.model = new AllNutrient();
            this.collection = new CNutrients();
            this.macronutrients = new CNutrients();
            this.micronutrients = new CNutrients();
        },

        getMacronutrients: function() {
            return this.macronutrients.toJSON();
        },
        getMicronutrients: function() {
            return this.micronutrients.toJSON();
        },
        getNutrients: function() {
            this.collection.toJSON();
        },

        onSync: function() {
            var macronutrients = this.macronutrients,
                micronutrients = this.micronutrients,
                collection = this.collection,
                model = this.model;
            macronutrients.reset(model.get('macronutrients'));
            micronutrients.reset(model.get('micronutrients'));
            collection.reset();
            collection.add(macronutrients.models);
            collection.add(micronutrients.models);
        },

    });

    return new NutrientService();
});

